const footerStyle = () => ({
  root: {
    bottom: "0"
  }
});

export default footerStyle;
